<template>
  <div class="promotion_new">
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Edit Banner</h1>
    </div>

    <form class="form" @submit.prevent="handleSubmit">
      <img v-if="file !== ''" src="" alt="" />
      <div class="form-group">
        <label>Name</label>
        <input
          v-model="banner.name"
          class="form-control"
          placeholder="Banner name ..."
        />
      </div>

      <div class="form-group">
        <label>Upload Image Link</label>
        <input
          type="file"
          id="file"
          ref="file"
          v-on:change="handleFileUpload"
          class="form-control"
        />
        <br />
        <progress max="100" :value.prop="uploadPercentage"></progress>
      </div>
      <div class="form-group">
        <img :src="bannerSource()" alt="" srcset="" style="width: 50%"/>
      </div>
      <br />

      <input type="submit" class="btn btn-primary" />
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { global } from "@/global";

export default {
  name: "banner_new",

  data() {
    return {
      banner: {
        name: "",
        id: "",
        banner_link: "",
      },

      file: "",
      uploadPercentage: 0
    };
  },

  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    handleSubmit() {
      if (this.file !== "" && this.banner.name !== "") {
        this.updateBanner();
      } else {
        swal({
          title: "Try Again",
          text: "All fields are required.",
          icon: "error"
        });
      }
    },

    updateBanner() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/banners/update/" + id,
            {
              name: this.banner.name,
              _method: "post"
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            if (!res.data.success) {
              swal({
                text: res.data.message,
                icon: "warning",
                button: "OK"
              });
            } else {
              this.uploadBanner(res.data.banner_id);

              swal({
                text: "Successful",
                icon: "success",
                button: "OK"
              });
            }
          });
      }
    },

    getDetail() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/banners/" + id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.banner.banner_link = res.data[0].banner_link;
            this.banner.name = res.data[0].name;
            this.banner.id = id;
          });
      }
    },

    uploadBanner(id) {
      let token = localStorage.getItem("token");

      let formdata = new FormData();

      formdata.append("name", this.file);
      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post("/banners/" + id + "/upload", formdata, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: function(progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }.bind(this)
          })
          .then(res => {});
      }
    },

    bannerSource() {
      return `${global.base_url}/${this.banner.banner_link}`;
    }
  },

  mounted() {
    this.getDetail();
  }
};
</script>
